import React from 'react';
import styles from './DashboardPage.module.css';

const DashboardTrends: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h2>Trends</h2>
      </header>
      <section className={styles.sectionDark}>
        <p>Trends content – coming soon.</p>
      </section>
    </div>
  );
};

export default DashboardTrends;
